
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import { Maintenance } from "../../assets/img";
import dayjs from "dayjs";

const MaintenancePage = ({details}) => {
const formatMaintenanceTime = (date) => {
  if (!date) return "--";
  return dayjs(date).format("DD MMM YYYY, hh:mm A");

};
    return (
        <>
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#f7f9fc",
                    px: 1,
                    p:{xs:3}
                }}
            >
                <Paper
                    elevation={6}
                    sx={{
                        maxWidth: 900,
                        width: "100%",
                        borderRadius: 4,
                        p: { xs: 3, md: 5 }}}
                >
                    <Grid sx={{
                        display:'flex',justifyContent:'center',alignItems:"center",marginBottom:'12px'
                    }}>
                        <Box src="/images/cohere_logo.gif" alt="Cohere Logo.gif" component="img" sx={{maxWidth:260}}/>
                    </Grid>
                    <Grid
                        container
                        spacing={6}
                        alignItems="center"
                        justifyContent="space-evenly">
                        <Grid item xs={12} md={6} >
                            <Maintenance height={"150px"} width={"150px"}/>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography
                                variant="h4"
                                gutterBottom
                                sx={{ fontWeight: 600, color: "text.primary" }}
                            >
                                {details?.maintenanceTitle || "Maintainance Mode"}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ mb: 2, color: "text.secondary" }}
                            >
                                <strong>Expected Downtime:</strong>
                                <br />
                               {formatMaintenanceTime(details?.maintenanceStartTime)} –  {formatMaintenanceTime(details?.maintenanceEndTime)} 
                            </Typography>
                            <Typography variant="body1" sx={{ color: "text.secondary" }}>
                                Thank you for your patience.<br />
                                We’ll be back shortly.<br />
                                {details?.maintenanceMessage}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </>
    )
};


export default MaintenancePage;